import AudiencePage from '@/components/marketing/technology/AudiencePage'
import type { TechnologyAudienceProps } from '@/types/technology'

/* /technology/managed-services — the catalogue owners' audience page.
 *
 * No widget: its onboarding-steps visual is the template's own numbered "How it
 * works" timeline, so nothing heavy is loaded and the steps are said once.
 */
export default function ManagedServices(props: TechnologyAudienceProps) {
  return <AudiencePage {...props} />
}
